import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { SwalErrorService } from './swal-error.service';

@Component({
  selector: 'app-swal-error',
  template: '',
})
export class SwalErrorComponent implements OnInit, OnDestroy {
  private sub: Subscription;

  private defaultObj = {
    title: 'AN_ERROR_HAS_OCCURRED',
    text: '',
    showCancelButton: false,
    cancelButtonText: 'CANCEL',
    confirmButtonText: 'OK',
    type: 'error',
  };

  constructor(
    private errorSwalService: SwalErrorService,
    private translateService: TranslateService
  ) {}

  public ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public ngOnInit() {
    this.sub = this.errorSwalService.showError.subscribe((res: any) => {
      const data = {
        ...this.defaultObj,
        ...res,
      };

      if (data) {
        Swal.fire({
          title: this.translateService.instant(data.title),
          html: data.text,
          icon: data.type as any,
          showCancelButton: data.showCancelButton,
          cancelButtonText: this.translateService.instant(
            data.cancelButtonText
          ),
          confirmButtonText: this.translateService.instant(
            data.confirmButtonText
          ),
          buttonsStyling: false,
          customClass: {
            confirmButton: 'button button--filled',
            cancelButton: 'button button--outlined',
          },
        }).then((result) => {
          this.errorSwalService.actionSubject.next(result);
        });
      }
    });
  }
}
